import {ActionIcon, Flex, Group, SimpleGridProps, Stack} from "@mantine/core";
import {InsightEmpty} from "../InsightEmpty/InsightEmpty";
import {InsightChartContainer, InsightChartContainerProps} from "../InsightChartContainer/InsightChartContainer";
import {useTranslation} from "react-i18next";
import {LineChartProps} from "../../chart/LineChart/LineChart";
import {useNavigate} from "react-router-dom";
import {
  ContainerDNUStatisticsByTimeChart,
  ContainerDNUStatisticsByTimeChartProps
} from "../../chart/ContainerDNUStatisticsByTimeChart/ContainerDNUStatisticsByTimeChart";
import {IconChartDots3, IconSearch, IconTruck} from "@tabler/icons-react";
import {containsValue, transportMethod} from "@ots-frontend/ots-data";

export type ContainerDNUStatisticsByTimeProps =
  Pick<InsightChartContainerProps, 'containerProps' | 'loading'>
  & Pick<LineChartProps, 'id'>
  & SimpleGridProps
  & ContainerDNUStatisticsByTimeChartProps


export const ContainerDNUStatisticsByTimeInsights = (props: ContainerDNUStatisticsByTimeProps) => {
  const {
    id,
    fromDttm,
    toDttm = new Date().getTime(),
    snapshots,
    category,
    methods,
    splitMethods,
    ...rest
  } = props

  const {t} = useTranslation()
  const navigate = useNavigate()

  if (!snapshots) {
    return <InsightEmpty/>
  }

  return (
    <InsightChartContainer
      {...rest}
      title={t<string>("common.insight.containerdnubytime", "Usable Containers By Time")}>
      <Stack>

        <ContainerDNUStatisticsByTimeChart
          id={id}
          fromDttm={fromDttm}
          toDttm={toDttm}
          snapshots={snapshots}
          category={category}
          methods={methods}
          splitMethods={splitMethods}/>

        <Group position="apart" align="flex-end" spacing="xs">
          <Flex justify="flex-end">
            {(!methods || containsValue(methods, transportMethod.trucking)) &&
              <IconTruck size="1.125rem"/>
            }
            {(!methods || containsValue(methods, transportMethod.pipeline)) &&
              <IconChartDots3 size="1.125rem"/>
            }
          </Flex>
          <Flex justify="flex-end">
            <ActionIcon onClick={() => navigate("/insights/container-dnu")}>
              <IconSearch size="1.125rem"/>
            </ActionIcon>
          </Flex>
        </Group>
      </Stack>
    </InsightChartContainer>
  )
}
